import { cx } from '@/lib/cx';
import { SortAscIcon, SortDescIcon, SortIdleIcon } from './icons';

/**
 * The mark on a sortable column head.
 *
 * In `components/ui` because four tables draw it — the board, the users list and
 * both dictionaries — and it was four copies of the same ternary over three text
 * glyphs. The classes stay on the CALLER's stylesheet: each table already has a
 * `sortArrow`/`sortIdle` pair, and the alternative was a fifth module whose only
 * job was to restate them.
 */
export const SortArrow = ({
  sorted,
  dir,
  className,
  idleClassName,
}: {
  sorted: boolean;
  dir: 'ascending' | 'descending';
  // `| undefined` spelled out, not just `?`: `exactOptionalPropertyTypes` is on and
  // a CSS-module lookup is typed `string | undefined`, so every caller would have to
  // guard a class name that is always there.
  className?: string | undefined;
  /** Applied instead of the accent colour when the column is not the sorted one. */
  idleClassName?: string | undefined;
}) => {
  const Icon = !sorted ? SortIdleIcon : dir === 'ascending' ? SortAscIcon : SortDescIcon;

  return <Icon className={cx(className, !sorted && idleClassName)} />;
};
